// Product page: groups block-rendered elements into wrapper divs for layout.
// Shopify renders section blocks as flat siblings, so CSS alone can't regroup
// them into the nested layout Figma calls for - this does it client-side.
//
// Kept in its own file, separate from custom.js: custom.js is also edited
// directly on the live theme by another developer, and this logic kept
// getting reverted to an older version whenever that happened.

(function () {
if (!document.body.classList.contains('template-product')) return;

// Every selector is OPTIONAL: the group is built from whichever of them exist on
// this page, in the order listed. It used to bail unless ALL of them matched,
// which meant the wrapper was silently never created on most products - several
// of these blocks are conditional. `.product__certification` only renders for
// `brand_certified` brands (sections/main-product.liquid), so the brand+title
// wrapper never existed on an ordinary product. Only a group where NOTHING
// matches is skipped.
function wrapElements(selectors, wrapperClass) {
    // Grab the elements in the order the selectors are listed
    const nodes = [];
    const missing = [];
    selectors.forEach(function (sel) {
      const el = document.querySelector(sel);
      if (el) nodes.push(el); else missing.push(sel);
    });

    if (nodes.length === 0) {
      console.debug('[wrapElements] "' + wrapperClass + '" skipped - none of its selectors are on this page:', selectors);
      return false;
    }
    if (missing.length) {
      console.debug('[wrapElements] "' + wrapperClass + '" wrapping ' + nodes.length + ' of ' + selectors.length + ' - not on this page:', missing);
    }

    const first = nodes[0];
    const parent = first.parentElement;

    // Already wrapped. Re-append so a block that appeared after the first pass
    // still lands inside, and in the listed order.
    if (parent && parent.classList.contains(wrapperClass)) {
      if (nodes.some(function (n) { return n.parentElement !== parent; })) {
        nodes.forEach(function (n) { parent.appendChild(n); });
      }
      return true;
    }

    // Create the new wrapper
    const wrapper = document.createElement('div');
    wrapper.className = wrapperClass;

    // Insert wrapper where the first node currently sits
    first.parentNode.insertBefore(wrapper, first);

    // Move each node into the wrapper, preserving order
    nodes.forEach(function (node) {
    wrapper.appendChild(node);
    });

    return true;
}

function init() {
    wrapElements(
    ['.product__brand', '.product__title','.product__certification', 'product-description-more'],
    'product-brand-title-wrapper'
    );

    // add more groups here if needed:
    wrapElements(['.product__badges', '.product__price'], 'product-badge-price-wrapper');

    wrapElements(['.product-form-wrapper', '.trust-badges'], 'product-form-trust-badges-wrapper');

    // '.rte' alone is ambiguous: the product description block also renders as
    // <div class="rte ...">, and it sits earlier in the DOM than the EMI block,
    // so a bare '.rte' query grabs the description instead. ':has()' targets the
    // specific .rte that wraps the EMI content.
    wrapElements(
    ['.product-form-trust-badges-wrapper', '.product__inventory', '.rte:has(.emi-plans)'],
    'product-form-trust-inverntory-emi-wrapper'
    );
  }

if (document.readyState !== 'loading') {
    init();
} else {
    document.addEventListener('DOMContentLoaded', init);
}
})();
